(function ($) {
  // Testimonial carousel -> prefer Owl Carousel; fallback to Slick
  if ($(".testimonial-carousel").length) {
      // Testimonial carousel -> use Slick only and emulate Owl structure/classes
      if ($(".testimonial-carousel").length && $.fn.slick) {
        var $carousel = $(".testimonial-carousel");

        $carousel.on("init", function (event, slick) {
          // add owl container classes
          $carousel.addClass('owl-carousel owl-loaded owl-drag');

          // convert slick structural elements to owl-like classes for CSS
          $carousel.find('.slick-list').addClass('owl-stage-outer');
          $carousel.find('.slick-track').addClass('owl-stage');
          $carousel.find('.slick-slide').each(function () {
            $(this).addClass('owl-item');
          });

          // wrap arrows into owl-nav if present
          var $prev = $carousel.find('.owl-prev');
          var $next = $carousel.find('.owl-next');
          if ($prev.length && $next.length) {
            $prev.add($next).wrapAll('<div class="owl-nav"></div>');
          }

          // add owl-dot class to dots <li>, set roles and display for ul
          var $dots = $carousel.find('.owl-dots');
          $dots.attr('role', 'tablist').css('display', 'flex');
          $dots.find('li').each(function () {
            $(this).addClass('owl-dot').attr('role', 'presentation');
          });

          // ensure active class mirrors slick's active dot (use slick-active)
          setTimeout(function () {
            var current = $carousel.slick('slickCurrentSlide');
            $dots.find('li').removeClass('slick-active').eq(current).addClass('slick-active');
          }, 0);
        });

        $carousel.slick({
          autoplay: true,
          autoplaySpeed: 3000,
          dots: true,
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          adaptiveHeight: true,
          dotsClass: 'owl-dots',
          // render each paging item as a simple span inside the li
          customPaging: function (slider, i) {
            return '<span></span>';
          },
          prevArrow: '<div class="owl-prev"><i class="fa fa-angle-right"></i></div>',
          nextArrow: '<div class="owl-next"><i class="fa fa-angle-left"></i></div>',
          // responsive: show 1 item on small screens and scroll 1
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        // update owl-dot active class on change (sync slick-active)
        $carousel.on('afterChange', function(event, slick, currentSlide){
          var $dots = $carousel.find('.owl-dots');
          var slidesToScroll = (slick && slick.options && slick.options.slidesToScroll) ? slick.options.slidesToScroll : 1;
          var dotIndex = Math.floor(currentSlide / slidesToScroll);
          $dots.find('li').removeClass('slick-active').eq(dotIndex).addClass('slick-active');
        });
      }
  }

})(jQuery);
